module.exports = __webpack_public_path__ + "img/bayern-munich.85ee092f.png";